function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.44 218.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fusion-fsn-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M305.22,287A109.22,109.22,0,1,1,196,396.22,109.22,109.22,0,0,1,305.22,287h0Z",
    transform: "translate(-196 -287)",
    style: {
      fill: "#1e9ada",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.84,348c-27.09,41.55-43.73,99.25-50.22,118.85-3.65-37,15.62-87.36,29.73-117.13-6.49.3-41.09,2.74-60.26,22.55,0,0,10.35-31.8,70.11-41.45l0.2-.41c46.77-68.37,81.87-27.53,81.87-27.53-21.31-3.56-39.87,7.11-55.7,24.48,7.71-.3,57.63-0.91,72,38.6,0,0-28.92-20.72-87.76-18h0Zm33.79,47.64a21.74,21.74,0,1,0,21.71,21.74h0a21.69,21.69,0,0,0-21.71-21.74h0Z",
    transform: "translate(-196 -287)",
    style: {
      fill: "#fefefe"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7d637674.svg";
export { ForwardRef as ReactComponent };